/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react'

type LiveNowContextType = {
  liveNow: boolean
  setLiveNow: (newLiveNow: boolean) => void
}

export const defaultLiveNow = {
  liveNow: false,
  setLiveNow: () => {},
}

const LiveNowContext = createContext<LiveNowContextType>(defaultLiveNow)

export default LiveNowContext
